<template>
  <div class="salaryDetails container">

     <!-- ---------------------------------------  Approved Changes List -------------------------------------------------- -->
 	<div>
		<CModal title="Approved Changes" 
			color="info" :show.sync="approvedChangesModal" size="lg">	

			<vue-good-table :columns="colApprovedChanges" :rows="rowSalary"
									:pagination-options="pagination_options" :lineNumbers="true"
					>
					<!-- <div slot="table-actions">
						<CButton color="primary" v-on:click.prevent="showReport()">
							Show Report
						</CButton>
					</div> -->
			</vue-good-table>

		</CModal>
	</div>

     <!-- ------------------------------- Modal: Adjust User Salary ------------------------------------------ -->

<!-- {{userSalary.name}}, Department: {{userSalary.deptName}} -->

	<div>
		<CModal title="User Report" 
			color="info" :show.sync="payModal" size="lg">	
			<div slot="header">
				<h5>{{userSalary.name}}, Department: {{userSalary.deptName}}</h5>
			</div>	  
			<div slot="footer">
				<button class="btn btn-info" :disabled="isApproved"  v-on:click.prevent="serverCall('saveUserSalaryReport')">Save</button>
				<button class="btn btn-info ml-2" v-on:click.prevent="payModal=false">Close</button>
			</div>

			<form>
				<div class="form-group row">

					<div class="col-sm-6">
						<div class="card" style="background-color:lightblue">

							<h5 class="card-title ml-2">Pay</h5>
							<div class="form-group row">
								<div class="col-sm-5 ml-2">Base: {{userSalary.basePay}}</div>
								<div class="col-sm-5">HRA: {{userSalary.hraPay}}</div>
							</div>
							<div class="form-group row">
								<div class="col-sm-5 ml-2">Other: {{userSalary.otherPay}}</div>
								<div class="col-sm-5">Total: {{userSalary.salary}}</div>
							</div>

							<div class="form-group row">
								<label for="miscPay" class="col-sm-5 col-form-label ml-2">Misc Pay</label>
								<div class="col-sm-5">
									<input type="number" id="miscPay" class="form-control" 
											v-model="userSalary.miscPay">
								</div>
							</div>

							<br>
							<h5 class="card-title ml-2">Work Days</h5>

							<div class="form-group row">
								<div class="col-sm-5 ml-2">Total Days: {{userSalary.totalDays}}</div>
								<div class="col-sm-5">Days Worked: {{userSalary.workingDays}}</div>
							</div>

							<div class="form-group row">
								<label for="workingDaysOverride" class="col-sm-5 col-form-label ml-2">Days Worked - Adj</label>
								<div class="col-sm-5">
									<input type="number" id="workingDaysOverride" class="form-control" 
											v-model="userSalary.workingDaysOverride">
								</div>
							</div>

							<div class="form-group row">
									<div class="col-sm-5 ml-2">Leave/Year: {{userSalary.daysOffPerYear}}</div>
									<div class="col-sm-5">Leave So Far: {{userSalary.daysOff}}</div>
							</div>

							<div class="form-group row">
								<label for="daysOffThisPeriod" class="col-sm-5 col-form-label ml-2">Leave This Period</label>
								<div class="col-sm-5"> 
									<input type="number" id="daysOffThisPeriod" class="form-control" 
											v-model="userSalary.daysOffThisPeriod" disabled>
								</div>
							</div>

							<div class="form-group row">
								<label for="daysOffThisPeriodOverride" class="col-sm-5 col-form-label ml-2">Leave This Period - Adj</label>
								<div class="col-sm-5">
									<input type="number" id="daysOffThisPeriodOverride" class="form-control" 
											v-model="userSalary.daysOffThisPeriodOverride">
								</div>
							</div>
						</div>
					</div>

					<div class="col-sm-6">
						<div class="card" style="background-color:lightblue">

							<!-- <h5 class="card-title ml-2">Deductions</h5>
							<div class="form-group row">
								<label for="dedPT" class="col-sm-3 ml-2 col-form-label">Prof Tax</label>
								<div class="col-sm-2">
									<input type="checkbox" id="dedPT" class="form-control" 
											v-model="user.dedPT">
								</div>

								<label for="dedESIC" class="col-sm-3 ml-2 col-form-label">ESIC</label>
								<div class="col-sm-2">
									<input type="checkbox" id="dedESIC" class="form-control" 
											v-model="user.dedESIC">			
								</div>
							</div>
							<div class="form-group row">
								<label for="pf" class="col-sm-6 ml-2 col-form-label">PF %</label>
								<div class="col-sm-5">
									<input type="number" id="pf" class="form-control" 
											v-model="user.dedPFpercent">
								</div>
							</div> -->

							<h5 class="card-title ml-2">Deductions</h5>
							<div class="form-group row">
								<!-- <div class="col-sm-5 ml-2">Tax: {{userSalary.tax}}</div>
								<div class="col-sm-5">PF: {{userSalary.pf}}</div> -->
								<label for="dedPT" class="col-sm-3 ml-2 col-form-label">Prof Tax</label>
								<div class="col-sm-2">
									<input disabled type="checkbox" id="dedPT" class="form-control" 
											v-model="userSalary.dedPT">
								</div>

								<label for="dedESIC" class="col-sm-3 ml-2 col-form-label">ESIC</label>
								<div class="col-sm-2">
									<input disabled  type="checkbox" id="dedESIC" class="form-control" 
											v-model="userSalary.dedESIC">			
								</div>
							</div>
							<div class="form-group row">
								<label for="pf" class="col-sm-5 ml-2 col-form-label">PF %</label>
								<div class="col-sm-5">
									<input disabled type="number" id="pf" class="form-control" 
											v-model="userSalary.dedPFpercent">
								</div>		
							</div>

							<div class="form-group row">
								<label for="miscDed" class="col-sm-5 col-form-label ml-2">Misc Deduction</label>
								<div class="col-sm-5">
									<input type="number" id="miscDed" class="form-control" 
											v-model="userSalary.miscDed">
								</div>
							</div>

							<br>
							<h5 class="card-title ml-2">Advance</h5>
							<div class="form-group row">
								<label for="totalAdvance" class="col-sm-5 ml-2 col-form-label">Advance</label>
								<div class="col-sm-5">
									<input disabled type="number" id="totalAdvance" class="form-control" 
											v-model="userSalary.totalAdvance">
								</div>
							</div>

							<br>
							<h5 class="card-title ml-2">Loan</h5>
							<div class="form-group row">
								<div class="col-sm-5 ml-2">Total Loan: {{userSalary.totalLoan}}</div>
								<div class="col-sm-5">Scheduled Repay: {{userSalary.scheduledRepay}}</div>
							</div>

							<div class="form-group row">
								<label for="scheduledRepayOverride" class="col-sm-5 col-form-label ml-2">Scheduled Repay Adj</label>
								<div class="col-sm-5">
									<input type="number" id="scheduledRepayOverride" class="form-control" 
											v-model="userSalary.scheduledRepayOverride">
								</div>
							</div>

							<div class="form-group row">
								<label for="onetimeRepay" class="col-sm-5 col-form-label ml-2">Onetime Repay</label>
								<div class="col-sm-5">
									<input type="number" id="onetimeRepay" class="form-control" 
											v-model="userSalary.onetimeRepay">
								</div>
							</div>

							<div class="form-group row">
								<label for="addlLoan" class="col-sm-5 col-form-label ml-2">Additional Loan</label>
								<div class="col-sm-5">
									<input type="number" id="addlLoan" class="form-control" 
											v-model="userSalary.addlLoan">
								</div>
							</div>

						</div>
					</div>

				</div>

				<p class="text-danger" align="left">{{userAlert}}</p>
			</form>

		</CModal>
	</div>

    <!-- ---------------------------------------  Salary Details List -------------------------------------------------- -->

	<p class="font-weight-bold" align="center">
		Start Date: {{this.$route.params.startDate}} - End Date: {{this.$route.params.endDate}} - {{approvedText}}
	</p>

	<div align="center">
		<label for="loadingMsg" v-if="loading">{{loadingMsg}}</label>
		<scale-loader :loading="loading"></scale-loader>
	</div>

	<div class="row">
		<h5  class="ml-3">Download:</h5>

		<vue-excel-xlsx class="ml-3 mr-3"
			:data="rowSalary"
			:columns="payExcelFields"
			:filename="payReportName"
			:sheetname="'Pay'"
			>
			<h5>Pay Report</h5>
		</vue-excel-xlsx>

		<vue-excel-xlsx class="ml-3 mr-3"
			:data="rowSalary"
			:columns="taxExcelFields"
			:filename="taxReportName"
			:sheetname="'Taxes'"
			>
			<h5>Tax Report</h5>
		</vue-excel-xlsx>

		<vue-excel-xlsx class="ml-3 mr-3"
			:data="rowSalary"
			:columns="bankExcelFields"
			:filename="bankReportName"
			:sheetname="'Bank Transfer'"
			>
			<h5>Bank Transfer Report</h5>
		</vue-excel-xlsx>
	</div>
	<br>

	<vue-good-table :columns="colSalary" :rows="rowSalary"
							:pagination-options="pagination_options" :lineNumbers="true"
							@on-row-click="rowChanged" 
							>
			<div slot="table-actions">
				<CButton class="ml-2 mr-3" color="primary" v-on:click.prevent="openSalaryHeader()">
					Go Back
				</CButton>
				<!-- <CButton class="ml-2 mr-3" color="primary" v-on:click.prevent="showReport()">
					Pay Report
				</CButton>
				<CButton class="ml-2 mr-3" color="primary" v-on:click.prevent="showTaxReport()">
					Tax Report
				</CButton>
				<CButton class="ml-2 mr-3" color="primary" v-on:click.prevent="showBankTransfers()">
					Bank Transfers
				</CButton> -->
				<CButton class="ml-2 mr-3" color="primary" :disabled="isApproved==false" v-on:click.prevent="showApprovedChanges()">
                	Approved Changes
            	</CButton>
			</div>
			<template slot="table-row" slot-scope="props">
				<span v-if="props.column.field == 'basePay'">
					<span>{{props.row.basePayCal}}<br>/{{props.row.basePay}}</span> 
				</span>
				<span v-else-if="props.column.field == 'hraPay'">
					<span>{{props.row.hraPayCal}}<br>/{{props.row.hraPay}}</span> 
				</span>
				<span v-else-if="props.column.field == 'otherPay'">
					<span>{{props.row.otherPayCal}}<br>/{{props.row.otherPay}}</span> 
				</span>
				<span v-else-if="props.column.field == 'ProfessionalTax_User'">
					<span>{{props.row.ProfessionalTax_User}}<br>/{{props.row.ProfessionalTax_Org}}</span> 
				</span>
				<span v-else-if="props.column.field == 'ESIC_User'">
					<span>{{props.row.ESIC_User}}<br>/{{props.row.ESIC_Org}}</span> 
				</span>
				<span v-else-if="props.column.field == 'ProvidentFund_User'">
					<span>{{props.row.ProvidentFund_User}}<br>/{{props.row.ProvidentFund_Org}}</span> 
				</span>
				<span v-else>
					{{props.formattedRow[props.column.field]}}
				</span>
			</template>

	</vue-good-table>

	<p class="text-danger" align="left">{{alert}}</p>

	<main id="main">
	</main>

  </div>
</template>

<script>
import axios from "axios"
import ScaleLoader from "@/views/utils/ScaleLoader";
import { firebase } from '@firebase/app'
import "firebase/auth"

export default {
	name: 'salaryDetails',

    components: {
        ScaleLoader,
    },
		
	data () {
		return {
			alert: '',
			userAlert: '',
            loading: false,
			loadingMsg: null,

			payModal: false,
			approvedChangesModal: false,

			salaryDetails: [],
			salaryDetailsHtml: "",
			taxReportHtml: "",
			bankTransfersHtml: "",

			salaryHeaderDocId: "",

			userSalary: {},

			colSalary: [
                	{
							label: 'Department',
							field: 'deptName',
							html: false,
							thClass: 'small',
							tdClass: 'small',
                            filterOptions: {
                                enabled: true, 
                            },
                    },
					{
							label: 'User Name',
                            field: 'name',
                            type: 'text',
							html: true,
							thClass: 'small',
							tdClass: 'small',
                            filterOptions: {
                                enabled: true, 
                            },
					},
					{
							label: 'Pay Calculated',
                            field: 'salaryPayable',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'bg-light small',
					},

					{
							label: 'Total Days',
                            field: 'totalDays',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'Days Worked',
                            field: 'workingDaysOverride',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'Leave Days',
                            field: 'daysOffThisPeriodOverride',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},

					{
							label: 'Base Pay',
                            field: 'basePay',
                            type: 'text',
							html: false,
							thClass: 'small',
							tdClass: 'bg-light small',
					},	
					{
							label: 'HRA Pay',
                            field: 'hraPay',
                            type: 'text',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},	
					{
							label: 'Other Pay',
                            field: 'otherPay',
                            type: 'text',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},	

					{
							label: 'Prof Tax',
                            field: 'ProfessionalTax_User',
                            type: 'number',
							html: true,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'ESIC',
                            field: 'ESIC_User',
                            type: 'number',
							html: true,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'PF',
                            field: 'ProvidentFund_User',
                            type: 'number',
							html: true,
							thClass: 'small',
							tdClass: 'small',
					},

					{
							label: 'Advance',
                            field: 'totalAdvance',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'bg-light small',
					},
					{
							label: 'Misc Pay',
                            field: 'miscPay',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'Misc Ded',
                            field: 'miscDed',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'Loan O/S',
                            field: 'totalLoan',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'bg-light small',
                    },
					{
							label: 'Sched Repay',
                            field: 'scheduledRepayOverride',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'Addl Loan',
                            field: 'addlLoan',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: '1time Repay',
                            field: 'onetimeRepay',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					}
            ],

            pagination_options: {
                enabled: true,
                mode: 'records',
                perPage: 5,
                position: 'top',
                perPageDropdown: [5, 10, 15, 20],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            },

			rowSalary: [],
			curRowSelected: null,
			isApproved: false,
			approvedText:  "Not Approved Yet",

			payReportName: "Pay Report - " + this.$route.params.endDate,
			payExcelFields: [
				{ label: "Name",field: "name"},
				{ label: "Payable",field: "salaryPayable"},
				{ label: "Off Days",field: "offDays"},
				{ label: "Working Days",field: "totalDays"},
				{ label: "Days Worked",field: "workingDaysOverride"},
				{ label: "Leave",field: "daysOffThisPeriodOverride"},
				{ label: "Base",field: "basePay"},
				{ label: "HRA",field: "hraPay"},
				{ label: "Other",field: "otherPay"},
				{ label: "P Tax",field: "ProfessionalTax_User"},
				{ label: "ESIC",field: "ESIC_User"},
				{ label: "PF",field: "ProvidentFund_User"},
				{ label: "Advance",field: "totalAdvance"},
				{ label: "Misc Pay",field: "miscPay"},
				{ label: "Misc Ded",field: "miscDed"},
				{ label: "Loan",field: "totalLoan"},
				{ label: "Sched Repay",field: "scheduledRepayOverride"},
				{ label: "Onetime Repay",field: "onetimeRepay"},
				{ label: "Onetime Loan",field: "addlLoan"},
			],

			taxReportName: "Tax Report - " + this.$route.params.endDate,
			taxExcelFields: [
				{ label: "Name",field: "name"},
				{ label: "Days Worked",field: "workingDaysOverride"},
				{ label: "Base",field: "basePay"},
				{ label: "HRA",field: "hraPay"},
				{ label: "Other",field: "otherPay"},
				{ label: "P Tax - User",field: "ProfessionalTax_User"},
				{ label: "P Tax- Org",field: "ProfessionalTax_Org"},
				{ label: "ESIC - User",field: "ESIC_User"},
				{ label: "ESIC - Org",field: "ESIC_Org"},
				{ label: "PF - User",field: "ProvidentFund_User"},
				{ label: "PF - Org",field: "ProvidentFund_Org"},
			],
			
			bankReportName: "Bank Transfer Report - " + this.$route.params.endDate,
			bankExcelFields:  [
				{ label: "Name",field: "name"},
				{ label: "Bank",field: "Bank"},
				{ label: "Account No.",field: "BankAccount"},
				{ label: "IFSC",field: "IFSC"},
				{ label: "Amount",field: "salaryPayable"},
			],

			colApprovedChanges: [
                	{
							label: 'Department',
							field: 'deptName',
							html: false,
							thClass: 'small',
							tdClass: 'small',
                            filterOptions: {
                                enabled: true, 
                            },
                    },
					{
							label: 'User Name',
                            field: 'name',
                            type: 'text',
							html: true,
							thClass: 'small',
							tdClass: 'small',
                            filterOptions: {
                                enabled: true, 
                            },
					},
					{
							label: 'Current Advance',
                            field: 'totalAdvance',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'bg-light small',
					},

					{
							label: 'Previous Advance',
                            field: 'totalAdvancePrev',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'Current Loan',
                            field: 'totalLoan',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'bg-light small',
					},

					{
							label: 'Previous Loan',
                            field: 'totalLoanPrev',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
					{
							label: 'Current Leaves',
                            field: 'daysOff',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'bg-light small',
					},

					{
							label: 'Previous Leaves',
                            field: 'daysOffPrev',
                            type: 'number',
							html: false,
							thClass: 'small',
							tdClass: 'small',
					},
			],

		}
	},

	computed: {
	},

	mounted(){
		var self=this
		self.salaryHeaderDocId = self.$route.params.salaryHeaderDocId
		if (self.$route.params.approved=="Yes"){
			self.isApproved = true
			self.approvedText = "Approved"
		}
		else {
			self.isApproved = false
			self.approvedText = "Not Approved Yet"
		}

		if (self.salaryHeaderDocId){
			self.serverCall('getSalaryDetails')
		}
		else {
			self.openSalaryHeader()
		}
	
	},

	methods: {
        serverCall(name) {
            var self = this
			self.alert = null

			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					user.getIdToken(true).then(idToken => {
						var org = self.getUserOrg()
						switch(name) {
							case "getSalaryDetails":
								self.getSalaryDetails(idToken, org)
								break;
							case "saveUserSalaryReport":
								self.saveUserSalaryReport(idToken, org)
								break;
							default:
								console.log("Unknown function: " + name)
						}
					})
				}
				else {
					self.alert = "Please login first."
				}
			})

		},

		rowChanged(params){	
			// Current selected Row
			if (this.curRowSelected != null){
				// If new row is not same as previous row, uncheck previous row
				if (this.curRowSelected.originalIndex!=params.row.originalIndex)
					this.curRowSelected.vgtSelected = false
			}
			// New selected row
			this.curRowSelected = params.row
		},

        // Fetch salary details data for the given salaryHeader id
        getSalaryDetails(authToken, org) {
            var self = this
			self.alert = null

			var formData = new FormData();
            formData.append("salaryHeaderDocId", self.salaryHeaderDocId)

			// Set loading message
			self.loading = true
			self.loadingMsg = "Fetching Salary Report Details..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/getSalaryDetails/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						self.rowSalary = response.data.salaryDetailsList
						// self.salaryDetailsHtml = response.data.salaryDetailsHtml
						// self.taxReportHtml = response.data.taxReportHtml
						// self.bankTransfersHtml = response.data.bankTransfersHtml
					}
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
				.catch(function (error) {
					self.alert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
		},

		// Open salary adjustment for selected user
		openUserSalaryAdjustment(){
            var self = this
			self.alert = null

            // Check if User is selected
			if (self.curRowSelected==null){
				self.alert = "User not selected."
				return
			}

			// Initialize user salary object
			self.userSalary = self.curRowSelected

			// Show modal with user values
			//$('#userSalaryModal').modal('show')
			this.payModal = true
		},

		showApprovedChanges(){
			this.approvedChangesModal = true
		},

		// Save user salary adjustments
        saveUserSalaryReport(authToken, org) {
            var self = this
            self.userAlert = ""
			
            if (!self.userSalary.userDocId) {
                self.userAlert= 'User not specified.'
                return
            }
			
			var formData = new FormData()
			formData.append("salaryDataStr", JSON.stringify(self.userSalary))

			// Set loading message
			self.loading = true
			self.loadingMsg = "Saving Salary Report Adjustments..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/saveUserSalaryReport/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != '') {
						self.userAlert = response.data.err
					}
					else {
						// Refresh salary details on the screen
						self.serverCall('getSalaryDetails')	
						self.alert = ""				
						//$('#userSalaryModal').modal('hide')
						self.payModal = false
					}
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
				.catch(function (error) {
					self.userAlert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
		},

		showReport() {
			var win = window.open("", "Salary Report")
			win.document.body.innerHTML = this.salaryDetailsHtml
		},

		showTaxReport() {
			var win = window.open("", "Tax Report")
			win.document.body.innerHTML = this.taxReportHtml
		},

		showBankTransfers() {
			var win = window.open("", "Bank Transfers")
			win.document.body.innerHTML = this.bankTransfersHtml
		},

		// Open SalaryHeaders
		openSalaryHeader(){
            var self = this
			self.alert = null
			self.$router.push({ name: 'Past Pay Reports'
							 })
		},

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
